import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { RestService } from "../service/rest.service";
import { LoaderService } from "../service/loader.service";
import { api } from "../../environments/environment";
import { companies } from "../models/universal-json";
import { Message } from "../service/message.service";

@Component({
  selector: "app-example-monouse-component",
  template: `<std-modal *transloco="let t" cardClass="w-[calc(100vw-100px)] mt-[50px]" headerClass="bg-primary" [show]="true"
    [closeOnOutside]="false" (close)="autoDestory()">
    <div class="text-tertiary text-title" header>
      Valutazione 
    </div>
    <div content class="px-1 min-w-[400px]">
      <div>
        <div class="text-black mb-5 font-semibold text-[24px]">Aziende del partner</div>
        <div>
          @for (company of companies; track $index) {
            <input type="file" [id]="'image-input-' + $index" (change)="changeImage(company,$event,'image')" class="hidden" id="image">
            <input type="file" [id]="'logo-input-' + $index" (change)="changeImage(company,$event,'logo')" class="hidden" id="image">
            <div
                class="mt-5 p-2.5 flex-wrap rounded-[6px] flex items-center gap-5 bg-Swhite shadow-xl">
                <div class="h-fit w-[160px]">
                <div class="font-semibold text-[16px]">Immagine</div>
                <div (click)="openInput('image-input-' + $index)" class="h-[160px] w-[160px] border-black border-[2px] overflow-hidden rounded-md">
                  @if(company.image){<img class="w-fit mx-auto max-h-[160px]" [src]="baseUrl+'/uploads/'+company.image">}@else{
                    <div class="text-black font-bold text-[20px] pl-2 pt-2">NO IMAGE</div>
                  }
                </div></div>
                <div class="h-fit w-[160px]">
                  <div class="font-semibold text-[16px]">Logo</div>
                <div (click)="openInput('logo-input-' + $index)" class="h-[160px] w-[160px] border-black border-[2px] overflow-hidden rounded-md">
                  @if(company.logo){<img class="w-fit mx-auto max-h-[160px]" [src]="baseUrl+'/uploads/'+company.logo">}@else{
                    <div class="text-black font-bold text-[20px] pl-2 pt-2">NO LOGO</div>
                  }
                </div></div>
                @if(forms['temp-image-'+company.id]){<div class="h-fit w-[160px]">
                <div class="font-semibold text-[16px]">Nuova immagine</div>
                <div (click)="openInput('image-input-' + $index)" class="h-[160px] w-[160px] border-black border-[2px] overflow-hidden rounded-md">
                  <img class="w-fit mx-auto max-h-[160px]" [src]="forms['temp-image-'+company.id]">
                </div></div>}
                @if(forms['temp-logo-'+company.id]){<div class="h-fit w-[160px]">
                  <div class="font-semibold text-[16px]">Nuovo logo</div>
                <div (click)="openInput('logo-input-' + $index)" class="h-[160px] w-[160px] border-black border-[2px] overflow-hidden rounded-md">
                  <img class="w-fit mx-auto max-h-[160px]" [src]="forms['temp-logo-'+company.id]">
                </div></div>}
                <div class="flex place-content-between items-center w-[calc(100%-180px)]">
                    <!-- <div class="opacity-50 w-full">
                        <div class="text-font22px text-quaternary"
                            [title]="company.name">{{company?.name}}</div>
                        <div class="text-font18px text-quaternary">@for (category of company?.categories; track $index) {
                            {{category.name}}{{($index + 1) < company?.categories.length ? ' | ' : '' }} }</div>
                        </div> -->
                    </div>
                    <div class="w-full">
                      <span class="text-[22px] font-semibold">Dettagli</span>
          @for (element of ['name','description','email','website','specializations','references','certifications','eProcurement','businessDescription']; track $index) {
                  <div>
                    <!-- <span class="font-semibold">{{t(element)}}:</span> -->
                  
                  <!-- <input class="w-full border-[2px]"> -->
                  <std-input labelPosition="top" [label]="t(element)" customInputClass="custom-input" customLabel="label-input mt-2" type="text" [(ngModel)]="company[element]"></std-input>
                  <!-- {{company[element] == 'null' ? 'Non compilato' : company[element]}} -->
                </div>
                }
                <std-select [currentValue]="company.categoriesSelect" [data]="categoriesSelect" [closeOnSelection]="false" customClassClose="size-4" [iconClose]="'../assets/xmark-solid.svg'" [multiple]="true" [filterable]="true" customLabel="label-input mt-2"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event,company)"  [bindLabel]="'name'" [bindValue]="'id'"
          customClassContaier="border-primary custom-select" [label]="'Categorie'" labelPosition="top" [placeholder]="'Categorie'"> </std-select>
          <std-select (onChangeValue)="changeCompanyType(company,$event)" [currentValue]="company.type ? {value:company.type,label:t('typeCatalog.'+company.type)} : null" [data]="[{
          value: 1,
          label: 'Azienda'
        },{
          value: 2,
          label: 'Servizio'
        },
        {
          value: 3,
          label: 'Consulenza'
        }]" [closeOnSelection]="false" customClassClose="size-4" [iconClose]="'../assets/xmark-solid.svg'" [multiple]="false" [filterable]="false" customLabel="label-input mt-2"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          customClassContaier="border-primary custom-select" [label]="'Tipo'" labelPosition="top" [placeholder]="'Tipo'"> </std-select>
              <!-- <div><span class="font-semibold">Tipo compagnia:</span> {{company.type ? t('companyType.' + company.type) : 'Non compilato'}}</div> -->
              <!-- <div><span class="font-semibold">Categorie:</span> {{company?.categoriesMapped?.length > 0 ? company?.categoriesMapped.join(' - ') : 'Non compilato'}}</div> -->
              </div>
              <std-button (click)="saveEditCompany(company)" buttonClass="bg-tertiary mt-5 text-primary focus:bg-tertiary hover:bg-tertiary shadow-md" 
          class="w-full" type="secondary">
          Salva modifiche azienda
        </std-button>
                </div>
                
          }
          @if(companies.length == 0){
            <div class="text-black mt-5 font-semibold text-[24px]">Nessuna azienda</div>
          }
        </div>
      </div>
      <div class="flex gap-4 mt-5">
        <std-button buttonClass="bg-tertiary text-primary focus:bg-tertiary hover:bg-tertiary shadow-md" 
          (click)="changeApprovedStatus('REJECTED')" class="w-full" type="secondary">
          Rifiuta
        </std-button>
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary shadow-md" 
          (click)="changeApprovedStatus('APPROVED')" class="w-full">
          Approva
        </std-button>
      </div>
    </div>
  </std-modal>`,
  styles: [],
  standalone: false,
})
export class ApprovePartnerComponent implements OnInit {

  constructor(private host: ElementRef<HTMLElement>, private rest: RestService, private loader: LoaderService,private message:Message) { }

  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  categoriesSelect :any[] = []
  companies :any[] = []
  forms:any = {}
  baseUrl = api.baseUrl
  allSavedPreUpdate = 0
  savingAll = false
  statusToSend = ''

  ngOnInit(): void {
    
    this.getCategories()
    this.getCompanies()
  }

  getCompanies() {
    this.loader.on()
    let options = { "page": 1, limit: 9999, "filters": [{ "s": "userId", "v": this.fatherElement.id, "o": 1 }] }
    this.rest.get(`/catalog/partner?options=${JSON.stringify(options)}`).subscribe({
      next: (response: any) => {
        this.companies = response.data.map((res: any) => {
          let newRes = res
          if (res?.categories?.length > 0) {

            newRes.categoriesSelect = res.categories
            newRes.categoriesMapped = res.categories.map((cat: any) => cat.name)
          } else {
            newRes.categoriesSelect = []
          }
          delete newRes.categories
          return newRes
        })
        this.forms = {}
        this.loader.off(true)
      },
      error: () => {
        this.loader.off(true)
      },
    })
  }

  changeCompanyType(company:any,event:any){
    company.type = event.value
  }

  openInput(openInput:string){
    let myInput = document.getElementById(openInput)
    if(myInput){
      myInput.click()
    }
  }

  changeImage(company:any,event:any,type:string){
    const file = event.target.files[0];
    if(!this.forms[company.id]){
      this.forms[company.id] = new FormData()
    }
    this.forms[company.id].append(type,file)
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e:any) => {
        // e.target.result contiene la stringa Base64 completa
        this.forms['temp-'+type+'-'+company.id] = e.target.result;
    };

    reader.readAsDataURL(file);
    
  }

  mangageSelect(event:any,company:any){
    let categoriesToJoin = event.map((ev:any)=>ev.id.toString())
    company.categories = categoriesToJoin.join(',')
  }

  saveEditCompany(company:any){
    this.loader.on()
    if(!this.forms[company.id]){
      this.forms[company.id] = new FormData()
    }
    for (const [key, value] of Object.entries(company)) {
      this.forms[company.id].append(key, value);
    }
    this.rest.patch(`/tech/${company.userId}/products/${company.id}`,this.forms[company.id]).subscribe({
      next: (response:any) => {
        this.message.showMessage('Azienda modificata con successo','success')
        this.categoriesSelect = response
        this.loader.off(true)
        if(!this.savingAll){
        this.getCompanies()}else{
          this.allSavedPreUpdate = this.allSavedPreUpdate + 1
          if(this.companies.length == this.allSavedPreUpdate){
            this.finalApprove()
          }
        }
      },
      error: () => {
        this.loader.off(true)
      },
    })
  }

getCategories(){
  this.loader.on()
  this.rest.get(`/category/list`).subscribe({
      next: (response:any) => {
        this.categoriesSelect = response
        
        this.loader.off(true)
      },
      error: () => {
        this.loader.off(true)
      },
    })
}

  autoDestory() {
    this.host.nativeElement.remove();
  }

  changeApprovedStatus(status: string) {
    this.savingAll = true
    this.allSavedPreUpdate = 0
    this.statusToSend = status
    this.companies.forEach(company => {
      this.saveEditCompany(company)
    });
    
  }

  finalApprove(){
    this.loader.on()
    this.rest.patch(`/user/partner/${this.fatherElement.id}/status`, { status: this.statusToSend }).subscribe({
      next: () => {
        this.loader.off(true)
        window.location.reload()
      },
      error: () => {
        this.loader.off(true)
        window.location.reload()
      },
    })
  }
}
